import React, { useEffect, useState } from 'react'
import {
  Button,
  Grid,
  GridColumn,
  GridRow
} from 'semantic-ui-react'
import { APPLICANT_TYPES } from '../../constant/APPLICANT_TYPES'
import { GROUP_TYPES } from '../../constant/GROUP_TYPES'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import StateSelectFormField from '../form/common/inputs/StateSelectFormField'
import ControlledFormField from '../common/ControlledFormField'
import RegisteredFormField from '../common/RegisteredFormField'
import { updateApplicantRelatedFields } from '../../state/slice/form'
import { GROUP_NUMBER_TOOLTIP } from "../form/common/fieldgroups/GroupFields";
import validateFormReady from '../../util/validateFormReady'

const TERMS_AND_CONSENT_PDF = '/assets/docs/Terms-and-Consent.pdf';

export default function OnlineSubmissionForm() {
  const dispatch = useDispatch()
  const formOptions = useSelector(state => state.form.options)
  const employerOptions = useSelector(state => state.form.segments.employer.fields)
  const [agree, setAgree] = useState(false)
  const [formReady, setFormReady] = useState(false)

  useEffect(() => {
    dispatch(updateApplicantRelatedFields())
    setFormReady(agree && validateFormReady(formOptions, employerOptions))
  }, [formOptions, employerOptions, agree, dispatch])

  return <>
    <Grid stackable container>
      <GridRow>
        <GridColumn width={16}>
          <div className='Field'>
            <div className='Field-groupLabel'>Product(s)</div>
            <div className='Field-group Field-group--inline'>
              <RegisteredFormField
                path='options.life'
                inputType='checkbox'
                label='Life'
                id='life'
                name='product'
              />
              <RegisteredFormField
                path='options.disability'
                inputType='checkbox'
                label='Disability'
                id='disability'
                name='product'
                disabled={formOptions.applicantType.value === 'SP_ONLY'}
              />
              <RegisteredFormField
                path='options.ci'
                inputType='checkbox'
                label='Critical Illness/Specified Disease'
                id='criticalIllness'
                name='product'
                disabled={['PR', 'VI'].includes(formOptions.homeState.value)}
              />
            </div>
          </div>
        </GridColumn>
        <GridColumn computer={8} mobile={16} tablet={8}>
          <StateSelectFormField
            path='options.homeState'
            id='homeState'
            label='State of Residence'
          />
        </GridColumn>
        <GridColumn computer={8} mobile={16} tablet={8}>
          <RegisteredFormField
            path='options.applicantType'
            inputType='select'
            id='applicantType'
            label='Applicant Type'
            placeholder='Select Applicant'
            options={APPLICANT_TYPES}
          />
        </GridColumn>
        <GridColumn computer={8} mobile={16} tablet={8}>
          <RegisteredFormField
            id='groupNumberHome'
            path='segments.employer.fields.groupNumber'
            attachedLabel='G000'
            label='Group ID Number'
            maxLength={4}
            transform={(v) => v.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()}
            hoverDetail={GROUP_NUMBER_TOOLTIP}
          />
        </GridColumn>
        <GridColumn computer={8} mobile={16} tablet={8}>
          <StateSelectFormField
            path='options.situsState'
            id='situsState'
            label='Employer State'
          />
        </GridColumn>
        {formOptions.homeState.value === 'TX' && <GridColumn computer={8} mobile={16} tablet={8}>
          <RegisteredFormField
            path='options.groupType'
            inputType='select'
            id='groupType'
            label='Group Type'
            placeholder='Select Group Type'
            options={GROUP_TYPES}
          />
        </GridColumn>}
      </GridRow>
      <GridRow>
        <GridColumn width={16}>
          <ControlledFormField
            inputType='checkbox'
            label={<>I agree to the <a href={TERMS_AND_CONSENT_PDF} target='_blank' rel='noreferrer'>Terms & Conditions</a></>}
            id='terms-and-conditions'
            name='agree'
            value={agree}
            onChange={() => setAgree(!agree)}
          />
        </GridColumn>
        <GridColumn className='u-pT5' computer={3} tablet={4} mobile={16} floated='right'>
          <Button
            fluid
            disabled={!formReady}
            as={NavLink}
            to='/form'
            content='Begin'
            size='huge'
            primary
          />
        </GridColumn>
      </GridRow>
    </Grid>
  </>
}
